var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMsgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1972 24.0804C30.7608 23.9764 30.301 24.0499 29.9187 24.2847C29.5365 24.5195 29.2631 24.8965 29.1586 25.3328L28.3008 28.8782C27.7874 30.6404 26.9109 32.2757 25.7275 33.6788C23.5316 36.1663 20.6981 36.8926 16.8125 35.9662C12.9268 35.0398 10.7309 33.107 9.89598 29.8989C9.47069 28.1108 9.42492 26.2533 9.76161 24.4464L10.6194 20.9039C10.6713 20.6878 10.68 20.4635 10.6452 20.2441C10.6103 20.0246 10.5325 19.8141 10.4161 19.6247C10.2998 19.4354 10.1473 19.2708 9.96724 19.1405C9.78722 19.0102 9.58325 18.9166 9.36703 18.8652L3.38267 17.4356C3.16657 17.3837 2.94236 17.375 2.72286 17.4099C2.50337 17.4447 2.29292 17.5226 2.10355 17.6389C1.91418 17.7552 1.74962 17.9078 1.61929 18.0878C1.48897 18.2678 1.39543 18.4718 1.34404 18.688L0.486275 22.2591C-0.176243 25.4154 -0.151864 28.6772 0.557756 31.8232C2.16178 38.6853 7.14828 43.4602 14.6051 45.2443C19.9519 46.5195 24.8583 45.8562 28.8813 43.3858C30.5156 42.3727 31.9755 41.1021 33.2044 39.6231C35.2578 37.1372 36.7536 34.2394 37.5905 31.1255L38.4482 27.5515C38.5001 27.3354 38.5089 27.1112 38.474 26.8917C38.4391 26.6722 38.3613 26.4618 38.245 26.2724C38.1287 26.083 37.9761 25.9185 37.7961 25.7882C37.6161 25.6578 37.4121 25.5643 37.1959 25.5129L31.1972 24.0804Z",
    fill: "url(#paint0_linear_2734_33589)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1164 10.8909C11.3376 10.9441 11.5671 10.9531 11.7917 10.9175C12.0164 10.8819 12.2319 10.8023 12.4257 10.6833C12.6196 10.5644 12.7881 10.4083 12.9216 10.2241C13.0551 10.0399 13.1509 9.83122 13.2037 9.60994L14.7562 3.54552C14.811 3.32448 14.8212 3.09474 14.7862 2.86972C14.7512 2.64469 14.6718 2.42889 14.5526 2.23487C14.4334 2.04086 14.2767 1.87251 14.0917 1.73967C13.9068 1.60683 13.6972 1.51216 13.4753 1.46115L7.56814 0.0486932C7.34697 -0.00449993 7.11748 -0.0135496 6.89281 0.0220625C6.66814 0.0576745 6.4527 0.137243 6.25883 0.256224C6.06495 0.375205 5.89644 0.53125 5.76296 0.715438C5.62947 0.899626 5.53362 1.10834 5.4809 1.32962L3.92833 7.39118C3.87514 7.61235 3.86609 7.84182 3.9017 8.06649C3.93731 8.29116 4.01689 8.50661 4.13587 8.70048C4.25485 8.89436 4.41091 9.06286 4.5951 9.19634C4.77928 9.32983 4.98799 9.42569 5.20927 9.47841L11.1164 10.8909Z",
    fill: "url(#paint1_linear_2734_33589)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8544 8.47755L35.2774 6.66766C35.071 6.61828 34.857 6.61003 34.6475 6.64336C34.438 6.6767 34.2371 6.75098 34.0563 6.86196C33.8754 6.97294 33.7183 7.11845 33.5937 7.29018C33.4691 7.46191 33.3796 7.65648 33.3302 7.86281L31.7033 14.2846C31.6045 14.7017 31.6751 15.1409 31.8997 15.5059C32.1243 15.871 32.4845 16.132 32.9013 16.2318L39.0344 17.6957C39.2408 17.7451 39.4548 17.7533 39.6643 17.72C39.8738 17.6867 40.0747 17.6124 40.2555 17.5014C40.4363 17.3904 40.5935 17.2449 40.7181 17.0732C40.8427 16.9014 40.9322 16.7069 40.9816 16.5005L41.9251 12.7464C43.0869 13.045 44.085 13.788 44.7042 14.8153C45.3235 15.8427 45.5146 17.0721 45.2361 18.2389L49.4878 19.254C50.0353 16.9454 49.6442 14.514 48.4005 12.4935C47.1568 10.473 45.1621 9.02864 42.8544 8.47755V8.47755Z",
    fill: "url(#paint2_linear_2734_33589)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2734_33589",
    x1: 13.0345,
    y1: 48.4042,
    x2: 26.2713,
    y2: -0.0195482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71E6B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33AFE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2734_33589",
    x1: -1.32299,
    y1: 44.4787,
    x2: 11.913,
    y2: -3.94132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71E6B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33AFE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2734_33589",
    x1: 30.5723,
    y1: 53.198,
    x2: 43.8091,
    y2: 4.77406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71E6B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33AFE1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgIcon);
export default __webpack_public_path__ + "static/media/msg-icon.44c9f08c637e53378402b7015b99ecdc.svg";
export { ForwardRef as ReactComponent };